import React, { useState } from "react";
import { GiScales } from "react-icons/gi";
import { HiUsers } from "react-icons/hi";
import { FaUserTie, FaArrowRight } from "react-icons/fa";
import { BsCheck2Circle } from "react-icons/bs";
import ban from "../../Asset/57173.jpg";
import { Link, useNavigate } from "react-router-dom";
import AppointmentModal from "../main/AppointmentModal";
 

const services = [
  { name: "LEGAL OPINION", link: "/legal-opinion" },
  { name: "PROPERTY REGISTRATIONS", link: "/property-register" },
  { name: "E-STAMP TO YOUR DOORSTEP", link: "/e-stamp" },
  { name: "PAN CARD, AADHAR UPDATION, PASSPORT, VOTER ID, GAZETTE", link: "/pancard" },
  {
    name: "CERTIFIED COPIES OF REVENUE DOCUMENTS (FORM DC/AC, THASILDHAR & SURVEY OFFICE)",
    link: "/revenue-documents",
  },
  { name: "Encumbrance Certificate / Registered Deeds Certified Copies", link: "/ec-certified-copies" },
  { name: "KATHA & TAX TRANSFER", link: "/katha-tax-transfer" },
  { name: "MARRIAGE REGISTRATION", link: "/marriage-registration" },
  { name: "LLP Name Approval, LLP Registration", link: "/llp-registration" },
  { name: "Pvt Ltd Company Registration, Digital Signature", link: "/private-ltd-registration" },
  { name: "GST, GST Filing", link: "/gst" },
  { name: "ITRs, TDS, TDS Filing", link: "/itrs-tds" },
  

];

const Banner = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="relative bg-black">
      {/* Background Image + Overlay */}
      <div className="absolute inset-0 bg-black/40 z-0" />
      <img
        src={ban}
        alt="Banner"
        className="absolute inset-0 w-full h-full object-cover opacity-40 z-0"
      />

      {/* Main Content */}
      <div className="relative z-10 w-full px-6 py-10 md:py-20 flex flex-col md:flex-row gap-8">
        {/* Left Content */}
        <div className="w-full md:w-1/2 text-white space-y-6">
          <p className="text-lg tracking-wide text-gray-300">
            — A Legal Journey with Expert Guidance for documentation to Purchase or Sale your property —
          </p>
          <h1 className="text-xl md:text-6xl font-bold leading-tight">
            Turning Legal Challenges <br />
            <span className="text-[#b7b7a1]">Into hassle-free </span>
           transaction for all your property, needs 
          </h1>
          <p className="text-lg text-gray-300 leading-relaxed">
           — With 26 years in the industry, our team has the expertise to handle complex property transactions and documentation —
          </p>
          <Link to ="/contact-us">
          <button className="mt-4 px-6 py-3 bg-[#b7b7a1] text-white text-lg font-semibold rounded-full shadow-md transition hover:bg-[#a0a08b] flex items-center gap-2 w-fit">
          Talk to us <span className="text-xl">↗</span>
          </button>
          </Link>
        </div>

{/* Right Content - Redesigned Services Grid */}
<div className="w-full md:w-1/2">
  <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border-l-4 border-[#b7b7a1] shadow-md h-full md:max-h-[600px] overflow-y-auto">
    <h2 className="text-2xl font-bold text-white mb-4 pb-2 border-b border-[#b7b7a1]">
      Our Services
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
      {services.map((service, idx) => (
        <Link
          to={service.link}
          key={idx}
          className="flex items-center gap-3 p-4 bg-white/5 hover:bg-[#b7b7a1]/20 transition-all border border-white/10 hover:border-[#b7b7a1] rounded-xl shadow-sm hover:scale-[1.02]"
        >
          <BsCheck2Circle className="text-[#b7b7a1] text-lg flex-shrink-0" />
          <span className="text-white text-sm font-medium leading-snug line-clamp-3">
            {service.name}
          </span>
          <FaArrowRight className="text-[#b7b7a1] text-sm ml-auto" />
        </Link>
      ))}
    </div>
  </div>
</div>


      </div>

      {/* Bottom Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full px-6 py-8 z-10">
        {[
     { icon: <FaUserTie className="text-white text-3xl" />, title: "Appointment", subtitle: "Book Your", onClick: () => setModalOpen(true) },

          { icon: <GiScales className="text-white text-3xl" />, title: "Expert Advice", subtitle: "Get Free"  ,onClick: () => navigate("/export-advice")  },
          { icon: <HiUsers className="text-white text-3xl" />, title: "Join Our Team", subtitle: "You Can Easily",onClick: () => navigate("/join-team")  },
        ].map((item, index) => (
          <div key={index}    onClick={item.onClick} className="relative group flex items-center hover:cursor-pointer bg-white h-24 overflow-hidden transition-all  ">
            <div className="bg-[#b7b7a1] p-8 md:p-10 flex items-center justify-center">
              {item.icon}
            </div>
            <div className="p-4 w-full relative">
              <p className="text-[#b7b7a1] text-sm">{item.subtitle}</p>
              <h3 className="text-lg font-semibold">{item.title}</h3>
              <div className="absolute top-4 right-2 opacity-0 -rotate-45 group-hover:opacity-100 group-hover:-translate-y-1 transition-all">
                <FaArrowRight className="text-[#b7b7a1] text-lg" />
              </div>
            </div>
          </div>
        ))}
        <AppointmentModal modalOpen={modalOpen} setModalOpen={setModalOpen} />

      </div>
    </div>
  );
};

export default Banner;
